module.exports = __webpack_public_path__ + "static/media/Maple-Hill-Architectural.cda49e36.pdf";